import {
  Breadcrumb,
  type BreadcrumbProps,
} from "@/components/Navigation/Breadcrumb";
import { defaultNS, useTranslation } from "@/lib/i18n";

export default function SoftwareBreadcrumb({ name }: { name: string }) {
  const { t } = useTranslation(defaultNS, { keyPrefix: "common.breadcrumbs" });

  const breadcrumbs: BreadcrumbProps[] = [
    { link: { to: "/software" }, label: t("software") },
    { link: { to: "/software/registry" }, label: t("registry") },
    { label: name },
  ];

  return <Breadcrumb breadcrumbs={breadcrumbs} />;
}
